import {
  handleAddCompany,
  handleDeleteCompany,
  handleEditCompany,
  handleRestoreCompany,
} from 'serviceWorker/services/companies';
import { companySource } from 'serviceWorker/services/companies/companySource';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { companyContract } from 'shared/domain/company/companyContract';
import { serveEntityRequests } from './serveEntityRequests';

/**
 * Answers the company requests. A change is answered once queued; its outcome
 * follows as an event with the change's `uniqueId`.
 */
export function serveCompanyRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(companyContract, companySource),
    channelServer.handle(companyContract, {
      create: handleAddCompany,
      edit: handleEditCompany,
      remove: handleDeleteCompany,
      restore: handleRestoreCompany,
    }),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
